<template>
  <v-autocomplete
    color="primary"
    v-model="materialsSelected"
    :clearable="!unclearable"
    :items="materialsItems"
    :loading="materialsLoading"
    :search-input.sync="materialsSearch"
    item-value="material_id"
    item-text="Description"
    item-disabled="disabled"
    :label="noLabel ? '' : label ? label : $t('Material.title')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  >
  </v-autocomplete>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import StockMaterialPsitions from "@/api/stock_material_positions";
import StockMaterials from "@/api/stock_materials";

export default {
  name: "SearcherStockAndStockPosition",

  props: {
    positionId: Number,
    stockId: Number,
    value: Object,
    noLabel: Boolean,
    label: String,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
  },

  computed: {
    materialsItems() {
      var item = this.materials.map((material) => {
        const Description = this.dense
          ? material.material_name
          : material.group_id
          ? material.material_name
          : i18n.t("Material.materialNameWithCodeAndStandard", [
              material.material_code,
              material.material_name,
              material.standard_name,
            ]);
        const disabled = material.group_id ? material : false;
        return Object.assign({}, material, { Description, disabled });
      });
      return item;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    materials: [],
    materialsLoading: false,
    materialsSearch: "",
    materialPosition: [],
    materialStock: [],
    materialsSelected: null,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.materialsSelected = this.value;
      },
    },
    materialsSelected: {
      handler() {
        this.$emit("input", this.materialsSelected);
      },
    },
    positionId: {
      handler() {
        this.materialPosition = [];
        this.materialStock = [];
        this.materials = [];
        if (typeof this.positionId != "undefined" && this.positionId != null) {
          StockMaterialPsitions.fetchAll({
            stock_position_id: this.positionId,
          }).then(
            function (response) {
              if (response.data.status.isOK()) {
                if (response.data.materials.length) {
                  this.materials.splice(0, 0, {
                    material_id: 0,
                    group_id: 1,
                    material_name: i18n.t(
                      "StockTakeOrders.DetailFields.stock_position_material"
                    ),
                  });
                  this.materialPosition = response.data.materials;
                  this.materialPosition.forEach((material_position) => {
                    material_position.material_id = material_position.id;
                  });
                  this.materials = this.materials.concat(this.materialPosition);

                  if (
                    typeof this.stockId != "undefined" &&
                    this.stockId != null
                  ) {
                    StockMaterials.fetchAll({ stock_id: this.stockId }).then(
                      function (response) {
                        if (response.data.status.isOK()) {
                          if (response.data.materials.length) {
                            this.materials.splice(
                              this.materials.length + 1,
                              0,
                              {
                                group_id: 2,
                                material_name: i18n.t(
                                  "StockTakeOrders.DetailFields.new_material"
                                ),
                              }
                            );
                            this.materialStock = response.data.materials;
                            //移除与库位商品重复的库内商品
                            this.materialStock.forEach((detail, key) => {
                              var isFound = this.materialPosition.find(
                                (material_position) =>
                                  material_position.id == detail.material_id
                              );
                              if (isFound) {
                                this.materialStock.splice(key, 1);
                              } else {
                                detail.isNewMaterial = 1;
                              }
                            });
                            this.materials = this.materials.concat(
                              this.materialStock
                            );
                          }
                        }
                      }.bind(this)
                    );
                  }
                }
              }
            }.bind(this)
          );
        }
      },
    },
  },
};
</script>